// extracted by mini-css-extract-plugin
module.exports = {"htmlText":"ParsedHtmlText_htmlText__NVLdN"};